import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./AgregarImagenesProductos.css";
 const API = process.env.REACT_APP_API_URL

const AgregarImagenesProductos = () => {
  const [images, setImages] = useState([null, null, null, null, null]);
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");


  const handleImageChange = (e, index) => {
    const file = e.target.files[0];
    if (file) {
      const newImages = [...images];
      newImages[index] = file;
      setImages(newImages);
    }
  };

  const removeImage = (index) => {
    const newImages = [...images];
    newImages[index] = null;
    setImages(newImages);
  };

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    
    if (images.every(img => img === null)) {
      return alert("Por favor, selecciona al menos una imagen.");
    }

    setLoading(true);
    const formData = new FormData();
    images.forEach((img, i) => {
      if (img) formData.append(`image${i + 1}`, img);
    });

    try {
      
      const tokenActual = localStorage.getItem("token");

      const response = await fetch(API + `/imagenesProductos/subirImagenes/${id}`, {
        method: "POST",
        headers: { 
          "Authorization": `Bearer ${tokenActual}`,
        },
        body: formData,
      });

      

      if (response.ok) {
        alert("✅ Imágenes subidas con éxito");
        navigate("/");
      } else {
        alert("❌ Error al subir las imágenes");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("❌ Error de conexión");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="upload-container">
      <div className="upload-card">
        <header className="upload-header">
          <span className="step-badge">Paso 2 de 2</span>
          <h2>Galería del Producto</h2>
          <p>Sube hasta 4 fotos. La primera será la imagen principal.</p>
        </header>

        <form onSubmit={handleSubmit}>
          <div className="image-grid">
            {images.map((img, index) => (
              <div key={index} className={`image-slot ${img ? "has-image" : ""}`}>
                {img ? (
                  <div className="preview-container">
                    <img src={URL.createObjectURL(img)} alt="preview" />
                    <button type="button" className="remove-overlay" onClick={() => removeImage(index)}>
                      <span>Eliminar</span>
                    </button>
                  </div>
                ) : (
                  <label className="upload-placeholder">
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => handleImageChange(e, index)}
                      hidden
                    />
                    <div className="icon-add">+</div>
                    <span className="label-text">Foto {index + 1}</span>
                  </label>
                )}
              </div>
            ))}
          </div>

          <div className="actions">
            <button type="submit" className={`submit-btn ${loading ? "loading" : ""}`} disabled={loading}>
              {loading ? "Subiendo..." : "Finalizar y Guardar"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AgregarImagenesProductos;